




import { defineComponent, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SmartImage',
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    lazyLoad: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const loadingAttribute = computed(() =>
      props.lazyLoad ? 'lazy' : 'eager'
    );

    return { loadingAttribute };
  },
});
